import { apiQuery } from '../';

export const vouchApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getVouchOptions: builder.query({
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: '/vouch/options',
          };
        },
      }),

      getVouchJobs: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ searchTerm = null, filter = {} } = {}) => {
          if (searchTerm) {
            return {
              method: 'get',
              url: '/search/ats_jobs',
              params: { filter_value: searchTerm },
            };
          }
          const { department, office } = filter;
          if (department || office) {
            return {
              method: 'get',
              url: '/search/ats_jobs',
              params: { department, office },
            };
          }
          return {
            method: 'get',
            url: '/search/ats_jobs',
          };
        },
      }),

      getJob: builder.query({
        query: ({ contactId, jobId }) => {
          return {
            method: 'get',
            url: '/vouch/new',
            params: { contact_id: contactId, ats_job_id: jobId },
          };
        },
      }),

      vouchCandidate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { contactId, relationship, jobId, userId, note } = payload;
          const data = {
            contact_id: contactId,
            relationship,
            note,
          };
          if (jobId) {
            data['ats_job_id'] = jobId;
          } else {
            data['vouched_to'] = userId;
          }
          return {
            url: '/vouch',
            method: 'post',
            data,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetVouchOptionsQuery,
  useGetVouchJobsQuery,
  useGetJobQuery,
  useVouchCandidateMutation,
} = vouchApi;
